import { postSubmit } from "@ui-seeker/utils"
import { REPORT_STATUS, TIME_OUT_STATUS, STATUS_START_DELAY } from "@constants"
import { useCallback, useEffect } from "react"
import useBatchBackendApiPath from "./usePath";
import {adminIdStatusBatchList, tableBatchData, globalExecutionsTableBatchCellData} from "../../@signals";

export default function useManageBatchStatusMultiple() {
	const { multipleStatus } = useBatchBackendApiPath()

	const getStatus = useCallback(() => {
		let isMounted = true

		const fetchStatus = () => {
			if (document.hidden) {
				// a background tab keeps its timer but sends nothing; it catches up when shown again
				setTimeout(() => {
					if (isMounted) fetchStatus()
				}, TIME_OUT_STATUS)
				return
			}
			if (!!adminIdStatusBatchList.value.length) {
				postSubmit(multipleStatus, { executions: adminIdStatusBatchList.value.map(id => id) })
					.then(res => {
						if (!isMounted) return
						const filteredIds = Object.values(res)
							.filter(item => item?.status === REPORT_STATUS.RUNNING)
							.map(({ idBatch }) => idBatch)

						if (filteredIds.length !== adminIdStatusBatchList.value.length) {
							adminIdStatusBatchList.value = filteredIds
							tableBatchData.value = tableBatchData.value.filter(({ id_last_execution }) => filteredIds.includes(id_last_execution))
						}

						if (Object.keys(res).some(key => !res[key].ExecutionGlobalStatusComplete)) {
							setTimeout(() => {
								if (isMounted) fetchStatus()
							}, TIME_OUT_STATUS)
						}

						globalExecutionsTableBatchCellData.value = { ...globalExecutionsTableBatchCellData.value, ...res }
					})
			}
		}

		fetchStatus()

		return () => {
			isMounted = false
		}

	}, [adminIdStatusBatchList.value.length])

	useEffect(() => {
		// getStatus is recreated for every row that registers on mount: without the delay each one
		// restarted the poll and fired a POST, N of them for N running rows
		let stop
		const timer = setTimeout(() => { stop = getStatus() }, STATUS_START_DELAY)
		return () => {
			clearTimeout(timer)
			if (stop) stop()
		}
	}, [getStatus])
}